import {Injectable} from '@angular/core';
import {VideoObject} from '../models/video-model';
import {Observable, of} from 'rxjs';
import {ControllersService} from './controllers.service';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class DataService {

    public videoData: VideoObject;
    public autoplay = false;
    public countdown = false;
    public controls = false;
    public speed = false;
    public allowPause = false;
    public soundfs = false;
    public loop = false;

    public startTime = 0;

    private startSent = false;
    private sent0 = false;
    private sent25 = false;
    private sent50 = false;
    private sent75 = false;
    private sent100 = false;

    constructor(private controllers: ControllersService) {

    }

    getVideoInfo(secret: string): Observable<VideoObject> {
        if (this.videoData) {
            return of(this.videoData);
        } else {
            try {
                if (localStorage.getItem(secret + '_start') === 'sent') {
                    this.startSent = true;
                }

                if (localStorage.getItem(secret + '_0') === 'sent') {
                    this.sent0 = true;
                }

                if (localStorage.getItem(secret + '_25') === 'sent') {
                    this.sent25 = true;
                }

                if (localStorage.getItem(secret + '_50') === 'sent') {
                    this.sent50 = true;
                }

                if (localStorage.getItem(secret + '_75') === 'sent') {
                    this.sent75 = true;
                }

                if (localStorage.getItem(secret + '_100') === 'sent') {
                    this.sent100 = true;
                }
            } catch (e) {

            }

            return this.controllers.getVideoInfo(secret).pipe(map(value => {
                this.videoData = value;

                return value;
            }));
        }
    }

    public sendViewData(perc: number): void {
        if (this.videoData) {
            if (!this.startSent) {
                this.startSent = true;
                try {
                    localStorage.setItem(this.videoData.secret + '_start', 'sent');
                } catch (e) {

                }
                this.controllers.sendStatistics(this.videoData.id, this.videoData.secret, 'start').subscribe({
                    error: err => {
                        console.log(err);
                    }
                });
            }

            if (!this.sent0) {
                if (perc > 0) {
                    this.sent0 = true;
                    try {
                        localStorage.setItem(this.videoData.secret + '_0', 'sent');
                    } catch (e) {

                    }
                    this.controllers.sendStatistics(this.videoData.id, this.videoData.secret, '0').subscribe({
                        error: err => {
                            console.log(err);
                        }
                    });
                }
            }

            if (!this.sent25) {
                if (perc > 0.25) {
                    this.sent25 = true;
                    try {
                        localStorage.setItem(this.videoData.secret + '_25', 'sent');
                    } catch (e) {

                    }
                    this.controllers.sendStatistics(this.videoData.id, this.videoData.secret, '25').subscribe({
                        error: err => {
                            console.log(err);
                        }
                    });
                }

            }

            if (!this.sent50) {
                if (perc > 0.5) {
                    this.sent50 = true;
                    try {
                        localStorage.setItem(this.videoData.secret + '_50', 'sent');
                    } catch (e) {

                    }
                    this.controllers.sendStatistics(this.videoData.id, this.videoData.secret, '50').subscribe({
                        error: err => {
                            console.log(err);
                        }
                    });
                }
            }

            if (!this.sent75) {
                if (perc > 0.75) {
                    this.sent75 = true;
                    try {
                        localStorage.setItem(this.videoData.secret + '_75', 'sent');
                    } catch (e) {

                    }
                    this.controllers.sendStatistics(this.videoData.id, this.videoData.secret, '75').subscribe({
                        error: err => {
                            console.log(err);
                        }
                    });
                }
            }

            if (!this.sent100) {
                if (perc > 0.99) {
                    this.sent100 = true;
                    try {
                        localStorage.setItem(this.videoData.secret + '_100', 'sent');
                    } catch (e) {

                    }
                    this.controllers.sendStatistics(this.videoData.id, this.videoData.secret, '100').subscribe({
                        error: err => {
                            console.log(err);
                        }
                    });
                }
            }

        }
    }

}
